var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mt-popup',{staticClass:"model-bottom",style:(_vm.customStyles),attrs:{"position":"bottom","closeOnClickModal":_vm.closeOnClickModal},model:{value:(_vm.popupVisible),callback:function ($$v) {_vm.popupVisible=$$v},expression:"popupVisible"}},[_c('span',{staticClass:"iconfont icon-close",on:{"click":_vm.close}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }